export default class Course {
  id: number;
  name: string;
  difficulty?: string;
  difficultyCategories: string[];
  theme: string;
  imgUrl?: string;
  description: string;
  lessonCount: number;

  constructor({id, name, difficulty, difficultyCategories, theme, imgUrl, description, lessonCount}: Course) {
    Object.assign(this, {id, name, difficulty, difficultyCategories, theme, imgUrl, description, lessonCount});
  }
}